import { FC } from "react";

import { useTheme } from "app/shared";
import styles from "./SpecialConditions.module.scss";

interface ISpecialConditions {
  title: string;
  description: string;
}

const SpecialConditions: FC<ISpecialConditions> = ({ title, description }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.infoSection} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3
        className={`${styles.title} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        {title}
      </h3>
      <p
        className={`${styles.description} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default SpecialConditions;
